const { base_api } = require('../../configs/config.json');

const BASE_API = base_api;

const { PRODUCT, ABONNEMENT } = require('./types');

const axios = require('axios');
const HEADERS = {
    'Content-Type': 'application/json',
};

const getBounds = devis => {
    var date = new Date();
    date.setDate(date.getDate() + 1);
    const lowerBound = devis.resilierContrat ? date.toISOString().split('T')[0] : new Date().toISOString().split('T')[0];

    date.setDate(date.getDate() + 365);

    const upperBound = date.toISOString().split('T')[0];
    return [lowerBound, upperBound];
}

function savePrePaymentData(data, callback) {

    axios.post(`${BASE_API}/public/prepayments`, data, { headers: HEADERS })
        .then(response => {
            callback(response.data);
        })
        .catch(err => console.log('request failed: ', err));
}

const createMHPayment = (body) => {
    return axios.post(`${BASE_API}/public/payment/mh`, body, { headers: HEADERS });
}

const createPNOSadaPayment = (body) => {
    return axios.post(`${BASE_API}/public/payment/pnosada`, body, { headers: HEADERS });
}

const createOneShotPayment = (body) => {
    return axios.post(`${BASE_API}/public/payment/oneshot`, body, { headers: HEADERS });
}

const getAffiliation = (ref, product) => {
    return axios.get(`${BASE_API}/public/affiliation`, {
        headers: HEADERS, params: { agence_ref: ref, active: true, product }
    });
}

const verifyPromoCode = (code, type) => {
    return axios.get(`${BASE_API}/public/promo/status`, {
        headers: HEADERS, params: { code, type }
    });
}

const estimatePrice = (devis, product) => {
    if (product === PRODUCT.PNO) {
        return axios.post(`${BASE_API}/public/pno-seul/price`, devis, { headers: HEADERS });
    }
    if (product === PRODUCT.MH_TEMPO) {
        return axios.post(`${BASE_API}/public/trusti-mh-tempo/price`, devis, { headers: HEADERS });
    }
    return axios.post(`${BASE_API}/dh/estimate`, devis, { headers: HEADERS });
}

const amount_init = (devis) => {
    if (devis.abonnement === ABONNEMENT.monthly) {
        return devis.estimatedPrice / 12;
    }
    return devis.estimatedPrice;
}

const frais_dossier_init = (devis) => {
    if (devis.abonnement === ABONNEMENT.monthly) {
        return devis.frais_dossier / 12;
    }
    return devis.frais_dossier || 0;
}

const promo_init = (devis) => {
    let promo = (devis.promo || {}).value || 0;
    if (devis.abonnement === ABONNEMENT.monthly) {
        return promo / 12.0;
    }
    return promo;
}

const toCurrencyValue = val => {
    return parseFloat(val).toFixed(2);
}

const getFirstPayAmount = (devis) => {
    let price = amount_init(devis);
    let frais = frais_dossier_init(devis);
    let promo = promo_init(devis);
    return price + frais - promo;
}

const getPNODevis = id => {
    return axios.get(`${BASE_API}/public/pno-seul/${id}`, { headers: HEADERS });
}

const getMHDevis = id => {
    return axios.get(`${BASE_API}/public/devis_habitation/${id}`, { headers: HEADERS });
}

const getMHTempoDevis = id => {
    return axios.get(`${BASE_API}/public/trusti-mh-tempo/${id}`, { headers: HEADERS });
}

const putPNODevis = devis => {
    return axios.put(`${BASE_API}/public/pno-seul/${devis.id}`,devis, { headers: HEADERS });
}

const putMHDevis = devis => {
    return axios.put(`${BASE_API}/devis_habitation/${devis.id}`,devis, { headers: HEADERS });
}

const putMHTempoDevis = devis => {
    return axios.put(`${BASE_API}/trusti-mh-tempo/${devis.id}`,devis, { headers: HEADERS });
}

const createDevis = (devis, model_type) => {
    return axios.post(`${BASE_API}/en-ligne/prospect`, {devis, model_type}, { headers: HEADERS });
}

const getDevis = (id, product) => {
    if(product === PRODUCT.PNO) return getPNODevis(id);
    if(product === PRODUCT.MH_TEMPO) return getMHTempoDevis(id);
    return getMHDevis(id);
}

const putDevis = (devis, product) => {
    if(product === PRODUCT.PNO) return putPNODevis(devis);
    if(product === PRODUCT.MH_TEMPO) return putMHTempoDevis(devis);
    return putMHDevis(devis);
}

module.exports = {
    getBounds,
    savePrePaymentData,
    createMHPayment,
    createPNOSadaPayment,
    createOneShotPayment,
    getAffiliation,
    verifyPromoCode,
    amount_init,
    toCurrencyValue,
    frais_dossier_init,
    promo_init,
    getFirstPayAmount,
    estimatePrice,
    getDevis,
    putDevis,
    createDevis,
}